import { useAppSelector, useAppDispatch } from "@/redux";
import { setShownInquiryModal } from "@/redux/slices/appSlice";

export default function useApp() {
  const state = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();

  return {
    state,
    setShownInquiryModal: (shown: boolean) => dispatch(setShownInquiryModal(shown)),
  };
}
